export interface AppStats {
	name: string;
	nameEn: string;
	category: string;
	categoryEn: string;
	monthlyPageViews: number;
	appStoreUrl?: string;
}

export const appStats: AppStats[] = [
	{
		name: "ThreadMaster",
		nameEn: "ThreadMaster",
		category: "掲示板閲覧",
		categoryEn: "Forum Viewer",
		monthlyPageViews: 2738645,
		appStoreUrl: "https://apps.apple.com/jp/app/threadmaster/id6738635233",
	},
	{
		name: "複数人のシフト管理アプリ決定版",
		nameEn: "Team Shift Manager",
		category: "シフト管理",
		categoryEn: "Shift Management",
		monthlyPageViews: 438208,
	},
	{
		name: "ペアカレ",
		nameEn: "PairCale",
		category: "カップル向けカレンダー",
		categoryEn: "Couple Calendar",
		monthlyPageViews: 87071,
	},
	{
		name: "タップシフト",
		nameEn: "TapShift",
		category: "シフト管理",
		categoryEn: "Shift Management",
		monthlyPageViews: 10394,
		appStoreUrl: "https://apps.apple.com/jp/app/tapshift/id1509926814",
	},
	{
		name: "Simple Shift Calendar",
		nameEn: "Simple Shift Calendar",
		category: "シフトカレンダー",
		categoryEn: "Shift Calendar",
		monthlyPageViews: 7118,
	},
	{
		name: "MAX計算機",
		nameEn: "MAX Calculator",
		category: "筋トレ・フィットネス",
		categoryEn: "Fitness",
		monthlyPageViews: 2598,
	},
];

export const getTotalMonthlyPageViews = (): number => {
	return appStats.reduce((total, app) => total + app.monthlyPageViews, 0);
};
